import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";
import { Slide } from "react-awesome-reveal";
import { Dynamic } from "../../Context/ContextDynamic";

const BanniereHome = () => {
  const { setEmoji, emoji } = Dynamic();
  const [loading, setLoading] = useState(false);
  const emohi = [
    "🥹",
    "😂",
    "🤧",
    "😜",
    "😎",
    "🤔",
    "😋",
    "😭",
    "😄",
    "🤩",
    "😍",
    "☺️",
    "😌",
    "😴",
    "🥱",
    "🤪",
    "🥵",
    "😈",
    "👿",
    "💩",
  ];
  function getRandomEmoji() {
    const randomIndex = Math.floor(Math.random() * emohi.length);
    const wait = setTimeout(() => {
      setEmoji(emohi[randomIndex]);
      setLoading(true);
    }, 2000);
    return () => clearTimeout(wait);
  }
  useEffect(() => {
    if (!emoji) {
      getRandomEmoji();
    } else {
      setLoading(true);
    }
  }, []);
  return (
    <StyledBanniereHome>
      <h2 className="first-up">
        Emohup uniquement en Guyane{" "}
        {!loading && <span className="loader"></span>}
        {loading && <Slide direction="down">{emoji}</Slide>}
      </h2>
      {/* <strong> ⭐ Les petites annonces des particuliers</strong>
      <strong> ⭐ Les évènements a venir </strong>
      <strong>⭐ Les business du coin des particuliers/pros</strong> */}
    </StyledBanniereHome>
  );
};

export default BanniereHome;
const StyledBanniereHome = styled.div`
  width: 100%;
  height: 70vh;
  /* height: 100svh; */
  /* background: ${COLORS.green}; */
  background: linear-gradient(135deg, #2fac66, #0f0f1a, #1a1a2e);
  background-position: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  margin-bottom: 20px;
  .first-up {
    display: flex;
    font-size: 3.7em;
    display: flex;
    align-items: center;
    color: ${COLORS.white};
  }
  strong {
    color: ${COLORS.blue_sky};
    font-size: 1.5em;
    margin-top: 10px;
  }

  ///here
  .loader {
    width: 48px;
    height: 48px;
    border: 5px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @media screen and (max-width: 445px) {
    padding: 0px;
    .first-up {
      display: flex;
      font-size: 3.3em;
      margin-bottom: 20px;
      position: relative;
    }
    strong {
      font-size: 1em;
    }
    .loader {
      width: 40px;
      height: 40px;
      border: 5px solid #fff;
      border-bottom-color: transparent;
      border-radius: 50%;
      position: absolute;
      bottom: 5px;
      right: 5px;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }
  }
`;
